import type { User } from '#/domain/user/User'
import type { UserRepository } from '#/domain/user/UserRepository'

export class GetUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, organizationId?: string): Promise<User> {
    return this.repository.findById(userId, organizationId)
  }
}
